export default __webpack_public_path__ + "static/media/isa5.4f59b79c.jpg";